import { messageDriverSupport } from "../../api/user/messageDriverSupport";
import APHelpForm, { APHelpFormConfig } from "../../components/APHelpForm";
import ModalContainer from "../../components/ModalContainer";
import { AUTO_UX_PHONE_NUMBER, AUTO_UX_SUPPORT_BIO } from "../../types/App";

const ContactDriverSupport = ({
  onSubmit,
  regardingOpportunityId,
}: {
  onSubmit: () => void;
  regardingOpportunityId?: string;
}) => {
  const { mutateAsync: messageAsync } = messageDriverSupport({
    mutationOptions: { successAlertMessage: "Message sent. Check email." },
  });

  const config: APHelpFormConfig = {
    title: "We are here to help",
    bio: AUTO_UX_SUPPORT_BIO,
    phone: AUTO_UX_PHONE_NUMBER,
    callText: "Call",
    messageText: "Message the Experience Team",
    image: "/auto-ux-team.png",
    faq: {
      pageId: "help-activated-dossier",
      appLocationIdentifier: "ContactActivated-FAQList",
      opportunityId: regardingOpportunityId,
    },
  };

  const _onSubmit = async (message: string) => {
    messageAsync({
      message: message,
      regardingOpportunityId: regardingOpportunityId || undefined,
      pageUrl: window.location.pathname,
    });

    onSubmit();
  };

  return (
    <ModalContainer loading={false} title={undefined}>
      <APHelpForm config={config} onSubmit={_onSubmit} />
    </ModalContainer>
  );
};

export default ContactDriverSupport;
